import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { LoginService } from 'src/app/main/login/login.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private readonly injector: Injector, private readonly router: Router) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(catchError(err => {
            // NOT AUTHENTICATED, UNAUTHORIZED, NOT FOUND OR INTERNAL SERVER ERROR
            if (err.status === 401 || err.status === 403 || err.status === 404 || err.status === 500) {
                void this.router.navigate(['error', err.status]);
            }

            // LOGIN TIMEOUT
            if (err.status === 440) {
                const loginService = this.injector.get(LoginService);
                return from(loginService.logout()).pipe(switchMap(() => throwError(() => err)));
            }

            // ANY OTHER ERROR
            return throwError(() => err);
        }));
    }
}
